import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import { StyledH3 } from '../TextPageLandlord/TextPageLandlord.styles';

const ZappyrentTutelaInquilino = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Zappyrent tutela anche l’inquilino
      </StyledH3>
      <TextBody>
        Novità assoluta per il mondo degli affitti è che il servizio di
        protezione immobiliare{' '}
        <strong>Protezione Zappyrent tutela anche gli inquilini.</strong>
      </TextBody>
      <TextBody>
        Studenti universitari, studenti Erasmus o lavoratori fuori sede che,
        appoggiandosi a qualsiasi agenzia immobiliare, dovrebbero ricorrere alla
        fideiussione ne sono esonerati con Zappyrent. La piattaforma stessa{' '}
        <strong>si pone come garante dei pagamenti mensili.</strong>
      </TextBody>
      <TextBody>
        Questo aspetto rivoluzionario rappresenta un ulteriore vantaggio per{' '}
        <strong>i potenziali inquilini</strong> che, dopo aver visualizzato gli
        annunci di loro interesse,{' '}
        <strong>
          possono prenotare la casa a cui sono interessati mediante smartphone,
        </strong>{' '}
        risparmiando tutto il tempo dovuto alle visite di persona.
      </TextBody>
    </>
  );
};

export default ZappyrentTutelaInquilino;
